export class ButtonPlanToOrder {
    constructor(onClick) {
        this.onClick = onClick;
    }

    onAdd(map) {
        this._map = map;
        this._container = document.createElement("div");
        this._container.className = "mapboxgl-ctrl mapboxgl-ctrl-group mapboxgl-order-to-plan";
        this._container.innerHTML = `
            <button style="padding: 14px 12px;">
                <svg stroke="red" fill="#fff" stroke-width="0" viewBox="0 0 256 256" height="20px" width="20px" xmlns="http://www.w3.org/2000/svg">
                    <path d="M228.61,60.16A6,6,0,0,0,224,58H61L54.63,22.93A6,6,0,0,0,48.73,18H24a6,6,0,0,0,0,12H43.72L69.53,171.94a21.93,21.93,0,0,0,6.24,11.77A26,26,0,1,0,113.89,190h52.22A26,26,0,1,0,188,178H91.17a10,10,0,0,1-9.84-8.21L77.73,150H196.1a22,22,0,0,0,21.65-18.06L229.9,65.07A6,6,0,0,0,228.61,60.16ZM106,204a14,14,0,1,1-14-14A14,14,0,0,1,106,204Zm96,0a14,14,0,1,1-14-14A14,14,0,0,1,202,204Zm3.94-74.21A10,10,0,0,1,196.1,138H75.55L63.19,70H216.81Z">
                    </path>
                </svg>
            </button>`;
        this._container.addEventListener("contextmenu", (e) => e.preventDefault());
        this._container.addEventListener("click", this.onClick);
        return this._container;
    }

    onRemove() {
        this._container.parentNode.removeChild(this._container);
        this._map = undefined;
    }
}

export class ShowBaseMapPicker {
    constructor(onClick) {
        this.onClick = onClick;
    }

    onAdd(map) {
        this._map = map;
        this._container = document.createElement("div");
        this._container.className = "mapboxgl-ctrl mapboxgl-ctrl-group mapboxgl-baseMap-switcher";
        this._container.innerHTML = `<button style="padding: 14px;"></button>`;
        this._container.addEventListener("contextmenu", (e) => e.preventDefault());
        this._container.addEventListener("click", this.onClick);
        return this._container;
    }

    onRemove() {
        this._container.parentNode.removeChild(this._container);
        this._map = undefined;
    }
}

export class ButtonLayerPicker {
    constructor(onClick) {
        this.onClick = onClick;
    }

    onAdd(map) {
        this._map = map;
        this._container = document.createElement("div");
        this._container.className = "mapboxgl-ctrl mapboxgl-ctrl-group mapboxgl-layer-switcher";
        this._container.innerHTML = `<button style="padding: 14px;"></button>`;
        this._container.addEventListener("contextmenu", (e) => e.preventDefault());
        this._container.addEventListener("click", this.onClick);
        return this._container;
    }

    onRemove() {
        this._container.parentNode.removeChild(this._container);
        this._map = undefined;
    }
}

export class ButtonPlanPicker {
    constructor(onClick) {
        this.onClick = onClick;
    }

    onAdd(map) {
        this._map = map;
        this._container = document.createElement("div");
        this._container.className = "mapboxgl-ctrl mapboxgl-ctrl-group mapboxgl-plan-picker";
        this._container.innerHTML = `
            <button style="padding: 10px 10px; background: #011627;">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g id="SVGRepo_bgCarrier" stroke-width="2"></g>
                    <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                    <g id="SVGRepo_iconCarrier">
                        <g id="Edit / Add_To_Queue">
                            <path id="Vector" d="M3 9V19.4C3 19.9601 3 20.2399 3.10899 20.4538C3.20487 20.642 3.35774 20.7952 3.5459 20.8911C3.7596 21 4.0395 21 4.59846 21H15.0001M14 13V10M14 10V7M14 10H11M14 10H17M7 13.8002V6.2002C7 5.08009 7 4.51962 7.21799 4.0918C7.40973 3.71547 7.71547 3.40973 8.0918 3.21799C8.51962 3 9.08009 3 10.2002 3H17.8002C18.9203 3 19.4801 3 19.9079 3.21799C20.2842 3.40973 20.5905 3.71547 20.7822 4.0918C21.0002 4.51962 21.0002 5.07969 21.0002 6.19978L21.0002 13.7998C21.0002 14.9199 21.0002 15.48 20.7822 15.9078C20.5905 16.2841 20.2842 16.5905 19.9079 16.7822C19.4805 17 18.9215 17 17.8036 17H10.1969C9.07899 17 8.5192 17 8.0918 16.7822C7.71547 16.5905 7.40973 16.2842 7.21799 15.9079C7 15.4801 7 14.9203 7 13.8002Z" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                        </g>
                    </g>
                </svg>
            </button>`;
        this._container.addEventListener("contextmenu", (e) => e.preventDefault());
        this._container.addEventListener("click", this.onClick);
        return this._container;
    }

    onRemove() {
        this._container.parentNode.removeChild(this._container);
        this._map = undefined;
    }
}

export class Button3D {
    constructor(onClick) {
        this.onClick = onClick;
    }

    onAdd(map) {
        this._map = map;
        this._container = document.createElement("div");
        this._container.className = "mapboxgl-ctrl mapboxgl-ctrl-group";
        this._container.innerHTML = `<button>3D</button>`;
        this._container.addEventListener("contextmenu", (e) => e.preventDefault());
        this._container.addEventListener("click", this.onClick);
        return this._container;
    }

    onRemove() {
        this._container.parentNode.removeChild(this._container);
        this._map = undefined;
    }
}

export class ButtonLegal {
    constructor(onClick) {
        this.onClick = onClick;
    }

    onAdd(map) {
        this._map = map;
        this._container = document.createElement('div');
        this._container.className = 'mapboxgl-ctrl  mapboxgl-legal-switcher';
        this._container.innerHTML = `<button>Wichtige Informationen zu den dargestellten Daten, <u><b>Quellenangaben</b></u> und <u><b>Nutzungsbedingungen</b></u></button>`;
        this._container.addEventListener('contextmenu', (e) => e.preventDefault());
        this._container.addEventListener('click', this.onClick);
        return this._container;
    }

    onRemove() {
        this._container.parentNode.removeChild(this._container);
        this._map = undefined;
    }
}